/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_Noposts1Inputs */

const he_posts_noposts1 = /** @type {(inputs: Posts_Noposts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין פוסטים עדיין. צור את הפוסט הראשון שלך!`)
};

const en_posts_noposts1 = /** @type {(inputs: Posts_Noposts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No posts yet. Create your first post!`)
};

/**
* | output |
* | --- |
* | "No posts yet. Create your first post!" |
*
* @param {Posts_Noposts1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const posts_noposts1 = /** @type {((inputs?: Posts_Noposts1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_Noposts1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_noposts1(inputs)
	return en_posts_noposts1(inputs)
});
export { posts_noposts1 as "posts_noPosts" }